import { render, staticRenderFns } from "./GuideWatchVideoModal.vue?vue&type=template&id=fb663668&"
import script from "./GuideWatchVideoModal.vue?vue&type=script&lang=js&"
export * from "./GuideWatchVideoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports